import initSearchSelect from './search-select';
import initSearchHead from './search-head';
import axios from "axios";
import { loadNew } from '~/blocks/grid';
import './index.sass';
import {handleLikeCard} from "../../blocks/card";

export default () => {
  const $root = $('.search');
  const $btn = $root.find('.js-show-more');
  initSearchSelect();
  initSearchHead();

  if($btn.length) {
    $btn.on('click', function (e) {
      e.preventDefault();
      const $el = $(this);
      initAjax($el)
    });
  }

  const initAjax = ($el) => {
    if(!$el.data('url')) $el.hide();
    $root.find('.js-grid-container').append('<div class="list-loader list-loader--grid"></div>');
    $root.find('.search__list').append('<div class="list-loader"></div>');
    axios.get($el.data('url')).then((response) => {
      $root.find('.pagination').remove();
      const resp = response;
      const $illustrations = $(resp.data.items);
      const url = resp.data.url;
      if(!$el.hasClass('no-masonry')) {
        $root.find('.js-grid-container').append($illustrations);
        $illustrations.addClass('grid-hidden');
        loadNew($illustrations);
        handleLikeCard();
      }
      if(url) {
        $el.data('url', url);
      } else {
        $el.remove();
      }
      $root.find('.search__list').append($illustrations);
      $root.find('.list-loader').remove();
      if(resp.data.pagination) {
        $root.find('.search__pagination').append(resp.data.pagination);
      }
    }).catch((error) => {
      console.log(error.response)
    });
  }
}
